<template>
  <common-dialog :show.sync="innerVisible" title="意见反馈" widthClass="feed-back-dialog" :modal-append-to-body="false">
      <div class="feed-back-content">
        <div class="form">
          <div class="form-item">
            <div class="form-item-label">反馈国家</div>
            <div class="form-item-content">
              <SeletCountry v-model="feedbackInfo.visa_country_id"></SeletCountry>
            </div>
          </div>
          <div class="form-item">
            <div class="form-item-label">反馈内容<span class="required">*</span></div>
            <div class="form-item-content">
              <div class="textarea-box">
                <textarea class="textarea" placeholder="请描述您遇到的问题" :rows="5" :maxlength="200" v-model="feedbackInfo.content"></textarea>
                <div class="text-box"><span>{{feedbackInfo.content.length}}</span>/200</div>
              </div>
            </div>
          </div>
          <div class="form-item">
            <div class="form-item-label">联系方式</div>
            <div class="form-item-content">
              <el-input class="input" placeholder="为了更及时处理问题，请留下您的联系电话或微信" v-model="feedbackInfo.contact" :maxlength="50" size="large"></el-input>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <button @click="onSubmit" class="s-btn btn-blue btn-lg" :disabled="!feedbackInfo.content">提交</button>
      </div>
    </common-dialog>
</template>

<script>
import Http from '@/libs/http';
import utils from '@/libs/utils';
import CommonDialog from '@/components/common/modals/common-dialog/common-dialog';
import SeletCountry from '@/components/common/select-country';


export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    SeletCountry,
    CommonDialog,
  },
  data() {
    return {
      feedbackInfo: {
        visa_country_id: 0,
        content: '',
        contact: '',
      },
    };
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      },
    },
  },
  watch: {
    innerVisible() {
      this.onInit();
    },
  },
  methods: {
    // 弹窗初始化
    async onInit() {
      const { name, params } = this.$route;

      let visa_country_id = 0;
      switch (name) {
        case 'country':
          visa_country_id = +params.id;
          break;
        case 'product':
          visa_country_id = await this._getCountryIdByProduct(params.visa_product_id);
          break;
        default:
      }

      // 赋值
      this.feedbackInfo = {
        visa_country_id,
        content: '',
        contact: '',
      };
    },
    _getCountryIdByProduct(productId) {
      return new Promise((resolve, reject) => {
        Http.post('/sys/visa_product_query', {
          visa_product_id: productId,
        }).then((data) => {
          resolve(data.visa_country_id);
        }).catch((e) => {
          reject(e);
        });
      });
    },
    onSubmit() {
      Http.post('/peer_advice_add', {
        contact: this.feedbackInfo.contact || undefined,
        content: this.feedbackInfo.content,
        visa_country_id: this.feedbackInfo.visa_country_id || undefined,
      }).then(() => {
        utils.msg.success('感谢您的反馈，可在右上角站内消息查看回复信息');
        this.innerVisible = false;
      });
    },
  },
};
</script>

<style lang="less">
.feed-back-dialog{
  width: 600px;
}
</style>
<style lang="less" scoped>
.feed-back-content{
  padding: 24px;
  .form{
    .form-item{
      display: flex;
      margin-bottom: 24px;
      &:last-child{
        margin-bottom: 0;
      }
      .form-item-label{
        flex-shrink: 0;
        width: 80px;
        margin-right: 10px;
        font-size: 16px;
        color: #2F333D;
        line-height: 40px;
        .required{
          color: #FF6464;
        }
      }
      .form-item-content{
        flex-grow: 1;
        color: #2F333D;
        font-size: 14px;
        .input{
          font-size: 14px;
          height: 40px;
          outline: none;
          &::placeholder{
            color: #91999F;
          }
        }
        .textarea-box{
          position: relative;
          .textarea{
            font-size: 14px;
            padding-bottom: 40px;
            width: 100%;
            height: 220px;
            padding: 10px;
            border: 1px solid #DEE2E6;
            line-height: 24px;
            border-radius: 4px;
            outline: none;
            &::placeholder{
              color: #91999F;
              font-size: 14px;
            }
            &:focus{
              border: 1px solid #5e9be1;
            }
          }
          .text-box{
            position: absolute;
            right: 10px;
            bottom: 10px;
            font-size: 14px;
            color: #91999F;
            span{
              color: #599FFF;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/fixed-right-service/components/dialog/feedback-service-dialog.vue